import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from '@nebula/hooks';
import { ThemeContext } from 'styled-components';

import { ActionButton, ActionButtonsContainer, Spinner, ApplePayOption, GooglePayOption } from './actionButtons.styles';
import useExistingPaymentMethod from '../../../components/PaymentCaptureMethod/hooks/useExistingPaymentMethod';
import { PaymentMethodTypes } from '../../../components/PaymentCaptureMethod/constants.ts';
import GooglePay from '../../../components/PaymentCaptureMethod/PaymentMethodEntry/GooglePay';
import ApplePay from '../../../components/PaymentCaptureMethod/PaymentMethodEntry/ApplePay';
import usePaymentMethodSupported from '../../../hooks/usePaymentMethodSupported';

const ActionButtons = ({
  onCancel,
  isWebview,
  onWalletAuthSuccess,
  onWalletAuthFailure,
  onPayAndChangeDate,
  isTokenizing,
  isCvvValid,
}) => {
  const theme = useContext(ThemeContext);
  const { existingPaymentType } = useExistingPaymentMethod();
  const isPaymentMethodSupported = usePaymentMethodSupported();

  const isDesktop = useMediaQuery(theme.media.tabletPortraitMin);
  const showPayButton = existingPaymentType === PaymentMethodTypes.Card;
  const showApplePay = existingPaymentType === PaymentMethodTypes.ApplePay;
  const showGooglePay = existingPaymentType === PaymentMethodTypes.GooglePay;

  return (
    <ActionButtonsContainer>
      {showPayButton && (
        <ActionButton
          id="pay_and_change_date"
          label={isTokenizing ? <Spinner /> : 'Pay and change date'}
          buttonKind="primaryMagenta"
          buttonSize={isDesktop ? 'large' : 'small'}
          type="button"
          onClick={onPayAndChangeDate}
          disabled={isTokenizing || !isCvvValid || !onPayAndChangeDate}
        />
      )}
      {showApplePay && isPaymentMethodSupported && (
        <ApplePayOption disabled={isTokenizing}>
          <ApplePay isBillingDateChange onSuccess={onWalletAuthSuccess} onError={onWalletAuthFailure} />
        </ApplePayOption>
      )}
      {showGooglePay && isPaymentMethodSupported && (
        <GooglePayOption disabled={isTokenizing}>
          <GooglePay isBillingDateChange onSuccess={onWalletAuthSuccess} onError={onWalletAuthFailure} />
        </GooglePayOption>
      )}
      <ActionButton
        isWebview={isWebview}
        disabled={isTokenizing}
        label="Cancel"
        buttonKind="secondaryMagenta"
        buttonSize={isDesktop ? 'large' : 'small'}
        type="button"
        onClick={onCancel}
      />
    </ActionButtonsContainer>
  );
};

ActionButtons.propTypes = {
  onCancel: PropTypes.func.isRequired,
  isWebview: PropTypes.bool.isRequired,
  onWalletAuthSuccess: PropTypes.func.isRequired,
  onWalletAuthFailure: PropTypes.func.isRequired,
  onPayAndChangeDate: PropTypes.func,
  isTokenizing: PropTypes.bool,
  isCvvValid: PropTypes.bool,
};

export default ActionButtons;
